module.exports = __webpack_public_path__ + "static/media/who-16.cd0fa719.jpg";